import { Route } from '@angular/router';

export const ERROR_ROUTES: Route[] = [
  {
    path: '503',
    pathMatch: 'full',
    loadComponent: () =>
      import('../lib/service-unavailable-page/service-unavailable-page.component').then((m) => m.ServiceUnavailablePageComponent)
  },
  {
    path: '**',
    loadComponent: () =>
      import('../lib/page-not-found-page/page-not-found-page.component').then((m) => m.PageNotFoundPageComponent)
  }
];
